import { createRoot } from "react-dom/client";
import App from "./App";
import { preloadRoute, preloadAllRoutes } from "./routes";
import "./index.css";

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

// Preload the current route's code-split chunk before mounting so React's
// first render is synchronous. The server pre-renders each route's HTML into
// #root for instant paint; mounting only after the chunk is ready means that
// pre-rendered content is replaced by the real page, never by a blank
// Suspense fallback.
const mount = () => {
  createRoot(document.getElementById("root")!).render(<App />);
  // Once the current page is up, quietly preload the remaining route chunks
  // during idle time so client-side navigation never suspends into the
  // blank Suspense fallback.
  const preloadRest = () => void preloadAllRoutes().catch(() => {});
  if ("requestIdleCallback" in window) {
    requestIdleCallback(preloadRest, { timeout: 5000 });
  } else {
    setTimeout(preloadRest, 2000);
  }
};
preloadRoute(window.location.pathname).then(mount, mount);
